import { Empty, Pagination } from 'antd'
import { Row } from 'antd'
import Loader from '../../../../helper/Loader'
import usePagination from 'helper/usePagination'
import { CommonEventResp } from 'types/event/events'
import CommonEventCard from './CommonEventCard'
import LeagueManageModals from 'pages/Events/League/LeagueManageModals'
import { useSyncParamsWithRoute } from '../../Header/useUpdateParams'
import '../../styles/main-event.scss'
import SingleDateSelection from 'components/global/SingleDateSelection'
import { useEffect, useState } from 'react'
import moment from 'moment'
import { useGetCommonEventListing } from 'api/Events'

const CardView = ({ events, parms, setParms }: any) => {
  const [selectedDate, setSelectedDate] = useState()
  const [paginationInfo, onTableChange, PaginationNoTabel] = usePagination({
    totalCount: events?.count || 0,
    currentPage: parms.page,
    setParams: setParms,
  })

  const { updateRouteParams } = useSyncParamsWithRoute(parms, setParms)

  const PaginationChanger = (pagenumber: number, limit: number) => {
    updateRouteParams({ page: pagenumber, limit: limit })
  }

  const { isLoading, isFetching } = useGetCommonEventListing(parms)

  useEffect(() => {
    if (!selectedDate) return
    if (parms.date !== selectedDate) {
      setParms((prevParms: any) => ({
        ...prevParms,
        date: moment(selectedDate).format('YYYY-MM-DD'),
      }))
      updateRouteParams({
        date: moment(selectedDate).format('YYYY-MM-DD'),
        page: 1,
        limit: 10,
      })
    }
  }, [selectedDate])

  return (
    <>
      {/* Mounted once so the listing's "Manage league" actions can open the league modals */}
      <LeagueManageModals />
      <div className="flex gap-20px justify-between">
        <div className="flex-1">
          {isLoading || isFetching ? (
            <Loader />
          ) : events?.records?.length === 0 ? (
            <div className="w-full h-50vh flex align-center justify-center">
              <Empty />
            </div>
          ) : (
            <>
              {events?.records?.map((events: CommonEventResp) => {
                return (
                  <div className="border-btm w-full pb-20px" key={events._id}>
                    <CommonEventCard event={events} />
                  </div>
                )
              })}
              <div className="mb-20px mt-20px">
                {(events?.hasNextPage || events?.hasPrevPage) && (
                  <div className="text-right">
                    <Pagination
                      onChange={PaginationChanger}
                      defaultCurrent={parms.page}
                      total={events.count}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`
                      }
                      pageSize={parms.limit || 10}
                      showSizeChanger={false}
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </div>

        <div className="calendar-comp">
          <Row justify="center" className="justify-end">
            {/* <Col lg={21} span={24}> */}
            <div>
              <SingleDateSelection
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
              />
              <div className="flex justify-end">
                <button
                  disabled={isLoading || isFetching}
                  onClick={() => {
                    setSelectedDate(undefined)
                    setParms((prevParms: any) => ({
                      ...prevParms,
                      date: undefined,
                    }))
                    updateRouteParams({ date: null, page: 1, limit: 10 })
                  }}
                  className="borderd-btn mt-10px mx-auto"
                >
                  Clear
                </button>
              </div>
            </div>
            {/* </Col> */}
          </Row>
        </div>
      </div>
    </>
  )
}

export default CardView
